import React, { useRef, createRef, useState, useEffect } from "react";
import "./reward.css";
import CustomButton from "../../components/CustomButton/custombutton";
import add from "../../images/icons/add.png";
import apiUtil from "../../api/apiUtil";
import api from "../../api/api";
import Table from "../../components/Table/Table";
import { Box } from "@material-ui/core";
import close from "../../images/icons/close.png";
import { Form, Formik } from "formik";
import * as Yup from "yup";
import CustomInput from "../../components/CustomInput/CustomInput";
import AntFileUpload from "../../components/AntFileUpload/AntFileUpload";
import edit from "../../images/icons/edit.png";
import delete_icon from "../../images/icons/delete.png";
import view from "../../images/icons/view.png";
import CustomSearchBar from "../../components/CustomSearchBar/CustomSearchBar";
import getToken from "../getToken";
import img_coming_soon from "../../images/icons/coming_soon.png";
import deleted_success from "../../images/icons/deleted_success.png";
import DateRangePicker from "../../components/DateRangePicker/DateRangePicker";
import { format } from "date-fns";
import CustomSelect from "../../components/CustomSelect/CustomSelect";
import { Link, useLocation } from "react-router-dom";

const Redeem = () => {
  const refProductTable = createRef();
  const refRedemptionTable = createRef();
  const [isProduct, setIsProduct] = useState(true);
  const [isRedemption, setIsRedemption] = useState(false);
  const [isAddRedemePoint, setIsAddRedemePoint] = useState(false);
  const [activeGiftPoint, setActiveGiftPoint] = useState(1);
  const [keyword, setKeyword] = useState("");
  const redeemId = useRef(0);
  const [isEditRedemePoint, setIsEditRedemePoint] = useState(false);
  const [redeemProductDetail, setRedeemProductDetail] = useState({});
  const [isEditCustomerRewardProduct, setIsEditCustomerRewardProduct] =
    useState(false);
  const [customerRewardProductDetail, setCustomerRewardProductDetail] =
    useState({});
  const [showCouponInput, setShowCouponInput] = useState(false);
  const [showView, setShowView] = useState(false);

  const location = useLocation();
  let brandId = localStorage.getItem("brandId");

  const [redeemProductList, setRedeemProductList] = useState({
    isLoading: true,
    grouping: false,
    limit: apiUtil.getDefaultPageSize(),
    data: [],
    total: 0,
    page: 1,
  });

  const [redemptionList, setRedemptionList] = useState({
    isLoading: true,
    grouping: false,
    limit: apiUtil.getDefaultPageSize(),
    data: [],
    total: 0,
    page: 1,
  });

  const [paramRedeemProduct, setParamRedeemProduct] = useState({
    keyword: "",
    rowLimit: 10,
    currentPage: 1,
    sortBy: "",
    isDesc: true,
    brandId: brandId,
  });
  const retrieveRedeemProductList = (value = paramRedeemProduct) => {
    value.keyword = keyword || "";
    if (value.keyword) {
      value.currentPage = 1;
    }
    api
      .post("Admin/GetRedeemProductListByAdmin", value, getToken())
      .then((result) =>
        apiUtil.parseResult(
          result,
          (response) => {
            const data = response.data.data;
            if (response.data.code === 401) {
              alert(response.data.message);
              localStorage.removeItem("user");
              window.location.href = "/login";
            } else if (response.data.code === 200) {
              setRedeemProductList({
                isLoading: false,
                limit: data.rowLimit,
                data: data.data && data.data.length > 0 ? data.data : [],
                total: data.totalRecords,
                page: data.paging,
              });
            } else {
              setRedeemProductList({
                isLoading: false,
                grouping: false,
                limit: apiUtil.getDefaultPageSize(),
                data: [],
                total: 0,
                page: 0,
              });
            }
          },
          (error, type) => {
            alert(error);
          }
        )
      );
  };

  const [paramRedemption, setParamRedemption] = useState({
    keyword: "",
    rowLimit: 10,
    currentPage: 1,
    sortBy: "",
    isDesc: true,
    isLoading: true,
    type: activeGiftPoint,
  });
  const retrieveRedemptionList = (value = paramRedemption) => {
    value.keyword = keyword || "";
    api.post("Admin/GetRedeemListByAdmin", value, getToken()).then((result) => {
      apiUtil.parseResult(
        result,
        (response) => {
          const data = response.data.data;
          if (response.data.code === 401) {
            alert(response.data.message);
            localStorage.removeItem("user");
            window.location.href = "/login";
          } else if (response.data.code === 200) {
            setRedemptionList({
              isLoading: false,
              limit: data.rowLimit,
              data: data.data && data.data.length > 0 ? data.data : [],
              total: data.totalRecords,
              page: data.paging,
            });
          } else {
            setRedemptionList({
              isLoading: false,
              grouping: false,
              limit: 0,
              data: [],
              total: 0,
              page: 0,
            });
          }
        },
        (error, type) => {
          alert(error);
        }
      );
    });
  };

  useEffect(() => {
    retrieveRedemptionList();
  }, [paramRedemption, activeGiftPoint]);

  const btnRedeemProduct = () => {
    setIsProduct(true);
    setIsRedemption(false);
    setIsAddRedemePoint(false);
  };

  const btnRedemption = () => {
    setIsProduct(false);
    setIsRedemption(true);
  };

  const clickAddRedeemPoint = (e) => {
    e.stopPropagation();
    if (isEditRedemePoint) {
      setIsEditRedemePoint(false);
      setTimeout(() => setIsAddRedemePoint(true), 100);
    } else {
      setIsAddRedemePoint(!isAddRedemePoint);
    }
    setRedeemProductDetail({});
  };

  const clickBtnClose = () => {
    setIsAddRedemePoint(false);
    setIsEditRedemePoint(false);
    setIsEditCustomerRewardProduct(false);
    setShowCouponInput(false);
    setShowView(false);
  };

  const clickActiveGiftPoint = (newTab) => {
    setParamRedemption({
      ...paramRedemption,
      type: newTab,
    });
    if (activeGiftPoint != newTab) {
      setActiveGiftPoint(newTab);
    } else {
      setActiveGiftPoint(0);
    }
  };

  const onSubmitRedeemProductHandler = (values, actions) => {
    const redeemProduct = {
      brandId: brandId,
      name: values.name,
      pointRequired: values.point,
      quantity: values.quantity,
      rating: 0,
      description: values.description,
      type: values.code ? 2 : 1,
      code: values.code ? values.code : null,
      startDate: values.date[0].startDate,
      endDate: values.date[0].endDate,
      imageInfo: [
        {
          imageName: values.files[0].name,
          image: values.files[0].url.replace(/^data:(.*,)?/, ""),
        },
      ],
    };
    console.log(redeemProduct);

    api
      .post("Admin/CreateRedeemItemByAdmin", redeemProduct, getToken())
      .then((result) => {
        apiUtil.parseResult(
          result,
          (response) => {
            if (response.data.statusCode === 200) {
              alert("Redeem product saved successfully!!");
              // reset the inputs and clear values
              actions.resetForm();
              values = {};
              setIsAddRedemePoint(false);
              retrieveRedeemProductList();
            } else if (response.data.statusCode === 401) {
              alert(response.data.value.message);
              localStorage.removeItem("user");
              window.location.href = "/login";
            } else {
              alert(response.data.message);
            }
          },
          (error, type) => {
            alert(error);
            values = {};
          }
        );
      });
    actions.setSubmitting(false);
  };

  const AddRedeemProductFormValidation = (showCouponInput) =>
    Yup.object().shape({
      name: Yup.string().required("Please enter the name."),
      point: Yup.string().required("Please enter the point."),
      description: Yup.string().required("Please enter the description."),
      quantity: Yup.string().required("Please enter the quantity."),
      files: Yup.mixed().required("Please choose the images."),
      code: Yup.string().when([], {
        is: () => showCouponInput,
        then: Yup.string().nullable().required("Please enter the coupon code."),
        otherwise: Yup.string().nullable(),
      }),
    });

  const clickBtnEditRedeemProduct = (e, id) => {
    e.stopPropagation();
    clickBtnClose();
    setIsDeleted(false);
    getRedeemProductDetail(id);
    setTimeout(() => {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }, 0);
  };

  const getRedeemProductDetail = (id) => {
    console.log(id);
    setRedeemProductDetail({});
    api
      .get("Admin/GetRedeemProductById", { RedeemProductId: id }, getToken())
      .then((result) => {
        apiUtil.parseResult(
          result,
          (response) => {
            console.log(response);
            if (response.data.code === 401) {
              alert(response.data.message);
              localStorage.removeItem("user");
              window.location.href = "/login";
            } else if (response.data.value.code === 200) {
              setRedeemProductDetail(response.data.value.data);
              setIsEditRedemePoint(true);
              redeemId.current = id;
              if (response.data.value.data.code != null) {
                setShowCouponInput(true);
              } else {
                setShowCouponInput(false);
              }
            } else {
              alert(response.data.value.statusText);
            }
          },
          (error, type) => {
            console.log(error);
          }
        );
      });
  };

  const editRedeemProductSubmit = (values, actions) => {
    const redeemProduct = {
      redeemId: redeemId.current,
      name: values.name,
      pointRequired: values.point,
      quantity: values.quantity,
      rating: 0,
      type: values.code ? 2 : 1,
      code: showCouponInput ? values.code : null,
      startDate: format(new Date(values.date[0].startDate), "yyyy-MM-dd"),
      endDate: format(new Date(values.date[0].endDate), "yyyy-MM-dd"),
      description: values.description,
      updateImageInfo: [
        {
          imageName: values.files[0].name,
          image: values.files[0].url.replace(/^data:(.*,)?/, ""),
        },
      ],
    };
    console.log(redeemProduct);
    api
      .post("Admin/UpdateRedeemItemByAdmin", redeemProduct, getToken())
      .then((result) => {
        apiUtil.parseResult(
          result,
          (response) => {
            if (response.data.code === 401) {
              alert(response.data.message);
              localStorage.removeItem("user");
              window.location.href = "/login";
            } else if (response.data.value.code === 200) {
              alert("Redeem product updated successfully!!");
              // reset the inputs and clear values
              actions.resetForm();
              values = {};
              setIsEditRedemePoint(false);
              retrieveRedeemProductList(paramRedeemProduct);
            } else {
              console.log(response);
              alert(response.data.value.message);
            }
          },
          (error, type) => {
            console.log(error);
          }
        );
      });

    actions.setSubmitting(false);
  };

  const [isDeleted, setIsDeleted] = useState(false);
  const clickBtnDeleteRedeemProduct = (e, id) => {
    e.preventDefault();
    clickBtnClose();
    const confirmed = window.confirm(
      "Are you sure you want to delete this redeem product?"
    );
    if (confirmed) {
      api
        .post(`Admin/DeleteRedeemItemByAdmin?redeemId=${id}`, {}, getToken())
        .then((result) => {
          apiUtil.parseResult(
            result,
            (response) => {
              if (response.data.statusCode === 401) {
                alert(response.data.message);
                localStorage.removeItem("user");
                window.location.href = "/login";
              } else if (response.data.statusCode === 200) {
                setIsDeleted(true);
                retrieveRedeemProductList();
              } else {
                alert(response.data.value.message);
              }
            },
            (error, type) => {
              console.log(error);
            }
          );
        });
    }
  };

  const status_list = [
    { label: "Pending", value: 1 },
    { label: "Approved", value: 2 },
    { label: "Rejected", value: 3 },
  ];
  const clickBtnEditCustomerReward = (e, id, mode) => {
    e.stopPropagation();
    clickBtnClose();
    setIsDeleted(false);
    getCustomerRewardDetail(id, mode);
    setTimeout(() => {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }, 0);
  };
  const getCustomerRewardDetail = (id, mode) => {
    console.log(id);
    setCustomerRewardProductDetail({});
    api
      .get("Admin/GetCustomerRedeemItemDetail", { redeemId: id }, getToken())
      .then((result) => {
        apiUtil.parseResult(
          result,
          (response) => {
            console.log(response);
            if (response.data.code === 401) {
              alert(response.data.message);
              localStorage.removeItem("user");
              window.location.href = "/login";
            } else if (response.data.value.code === 200) {
              console.log(response.data.value.data);
              setCustomerRewardProductDetail(response.data.value.data);

              setShowView(mode === "view");
              setIsEditCustomerRewardProduct(mode !== "view");
              redeemId.current = id;
              console.log(redeemId.current);
            } else {
              alert(response.data.value.statusText);
            }
          },
          (error, type) => {
            console.log(error);
          }
        );
      });

    console.log(customerRewardProductDetail);
  };

  const onSubmitCustomerRewardProductHandler = (values, actions) => {
    const customerRewardProduct = {
      CustomerRedeemId: redeemId.current,
      Status: values.status,
    };
    console.log(customerRewardProduct);

    api
      .post(
        "Admin/ApproveCustomerRedeemItem",
        customerRewardProduct,
        getToken()
      )
      .then((result) => {
        apiUtil.parseResult(
          result,
          (response) => {
            console.log(response);
            if (response.data.code === 401) {
              alert(response.data.message);
              localStorage.removeItem("user");
              window.location.href = "/login";
            } else if (response.data.code === 200) {
              alert("Customer Reward Product status approved successfully!!");
              retrieveRedemptionList(paramRedemption);
              // reset the inputs and clear values
              actions.resetForm();
              values = {};
              setIsEditCustomerRewardProduct(false);
            } else {
              alert(response.data.message);
            }
          },
          (error, type) => {
            console.log(error);
          }
        );
      });

    actions.setSubmitting(false);
  };

  useEffect(() => {
    retrieveRedeemProductList();

    if (isDeleted) {
      const timeout = setTimeout(() => {
        setIsDeleted(false);
      }, 10000);

      return () => clearTimeout(timeout);
    }
  }, [paramRedeemProduct, isDeleted]);

  console.log(redeemProductDetail);
  console.log(redeemProductList);

  useEffect(() => {
    const pathname = location.pathname.substring(1);
    if (pathname === "reward/customer") {
      setIsRedemption(true);
      setIsProduct(false);
    } else {
      setIsProduct(true);
      setIsRedemption(false);
    }
  }, [location.pathname]);

  const getRedeemDate =
    redeemProductDetail.startDate && redeemProductDetail.endDate
      ? [
          {
            startDate: new Date(redeemProductDetail.startDate),
            endDate: new Date(redeemProductDetail.endDate),
            key: "selection",
          },
        ]
      : "";

  const getRedeemFiles = () => {
    if (redeemProductDetail.image) {
      return [
        {
          uid: "1",
          status: "done",
          url: redeemProductDetail.image,
        },
      ];
    } else {
      return null;
    }
  };
  function getValueOrDefault(value, defaultValue) {
    return value || defaultValue;
  }
  const getRewardDate = () => {
    return customerRewardProductDetail.redeemDate
      ? apiUtil.getDateShortMonthFormat(customerRewardProductDetail.redeemDate)
      : "";
  };

  const getRewardFiles = () => {
    return customerRewardProductDetail.image
      ? [
          {
            uid: "1",
            status: "done",
            url: customerRewardProductDetail.image,
          },
        ]
      : null;
  };

  return (
    <>
      {/* button list */}
      <div className="Actions flex-row Button_Holder">
        <button
          className={`product_btn ${isProduct ? "buttonActive" : ""}`}
          onClick={btnRedeemProduct}
        >
          Reward
        </button>
        <Link to="/reward/customer">
          <button
            className={`redemption_btn ${isRedemption ? "buttonActive" : ""}`}
            onClick={btnRedemption}
          >
            Customer's Reward List
          </button>
        </Link>
      </div>

      {/* delete button */}
      {isDeleted && (
        <div className="Actions justify-content-center  deleted-alert">
          <img src={deleted_success} alt="delete" />
          <p className="mb-0">
            The redeem product has been successfully deleted!
          </p>
        </div>
      )}

      {/* reward tab */}
      {isProduct && (
        <>
          {isAddRedemePoint || isEditRedemePoint ? (
            <>
              <div className="Actions space_between">
                <h6 className="title_text mt-2">Add Reward Product</h6>
                <button className="btn btnClose" onClick={clickBtnClose}>
                  <img src={close} className="imgClose" alt="imgClose" />
                </button>
              </div>

              <Formik
                initialValues={{
                  name: redeemProductDetail.name || "",
                  point: redeemProductDetail.pointRequired || "",
                  quantity: redeemProductDetail.quantity || "",
                  date: getRedeemDate,
                  description: redeemProductDetail.description || "",
                  code: redeemProductDetail.code || "",
                  files: getRedeemFiles(),
                }}
                enableReinitialize={true}
                validationSchema={AddRedeemProductFormValidation(
                  showCouponInput
                )}
                validateOnBlur={false}
                onSubmit={(values, actions) => {
                  if (isEditRedemePoint) {
                    editRedeemProductSubmit(values, actions);
                  } else {
                    onSubmitRedeemProductHandler(values, actions);
                  }
                }}
              >
                {/* input forms */}
                {({ values, errors, touched, setFieldValue }) => (
                  <Form className="row form-container redeem_form">
                    <div className="col-6">
                      <CustomInput
                        name="name"
                        type="text"
                        label="Name"
                        customclass="input_wrapper"
                        hideicon="true"
                      />
                    </div>

                    <div className="col-6">
                      <CustomInput
                        name="point"
                        type="text"
                        label="Point"
                        customclass="input_wrapper"
                        hideicon="true"
                      />
                    </div>

                    <div className="col-6 mt-2">
                      <CustomInput
                        name="quantity"
                        type="number"
                        label="Quantity"
                        customclass="input_wrapper"
                        hideicon="true"
                      />
                    </div>

                    <div className="col-6 mt-2">
                      <DateRangePicker
                        name="date"
                        label="Date"
                        customclass="input_wrapper"
                      />
                    </div>

                    <div className="col-12 mt-2">
                      <CustomInput
                        name="description"
                        label="Description"
                        textarea="true"
                      />
                    </div>

                    <div className="col-6 mt-2">
                      <div className="form-check">
                        <input
                          type="checkbox"
                          id="coupon"
                          name="coupon"
                          className="form-check-input"
                          checked={showCouponInput}
                          onChange={() => {
                            setShowCouponInput(!showCouponInput);
                          }}
                        />
                        <label htmlFor="coupon" className="form-check-label">
                          Coupon
                        </label>
                      </div>
                    </div>

                    {showCouponInput ? (
                      <div className="col-12 mt-2">
                        <CustomInput
                          name="code"
                          type="text"
                          label="Coupon Code"
                          customclass="input_wrapper"
                          hideicon="true"
                          isClearable={false}
                        />
                      </div>
                    ) : null}

                    <div className="col-12 mt-2">
                      {/* <FileUpload label="Images"/> */}
                      <AntFileUpload
                        name="files"
                        label="Image"
                        addIcon={true}
                        inputText="Drag and drop or browse to choose a file"
                        aspectRatio={9 / 3}
                        imageQuality={0.8}
                        accept={".png, .jpg, .jpeg"}
                        onChange={({ fileList: newFileList }) => {
                          if (newFileList.length > 0) {
                            if (newFileList.length > 1) {
                              newFileList.shift();
                            }
                            newFileList = newFileList.map((file) => {
                              return {
                                ...file,
                                status: "done",
                                percent: 100,
                                response: "Success",
                              };
                            });
                            const successFiles = newFileList.filter(
                              (file) => file.status !== "error"
                            );
                            const failedFiles = newFileList.filter(
                              (file) => file.status === "error"
                            );
                            if (failedFiles.length > 0) {
                              console.log(failedFiles);
                            }
                            setFieldValue("files", successFiles);
                          } else {
                            setFieldValue("files", null);
                          }
                        }}
                        onRemove={(file) => {
                          if (file.url) {
                            setFieldValue("deletedImage", [
                              ...values.deletedImage,
                              file,
                            ]);
                          }

                          if (values.files.length === 1) {
                            setFieldValue("files", null);
                          }
                        }}
                      />
                      {errors.files && touched.files && (
                        <div className="fileError">{errors.files}</div>
                      )}
                    </div>

                    <div className="form-group mt-4">
                      <div className="Actions justify-content-end">
                        <button
                          type="button"
                          className="button btnCancel"
                          onClick={clickBtnClose}
                        >
                          Cancel
                        </button>
                        <button type="submit" className="button btnSave">
                          {isAddRedemePoint ? "Create" : "Update"}
                        </button>
                      </div>
                    </div>
                  </Form>
                )}
              </Formik>
            </>
          ) : null}

          {/* banner & actions */}
          <div className="Actions space_between">
            {/* banner */}
            <h6 className="title_text mt-2">Rewards</h6>

            {/* actions */}
            <div className="d-flex justify-content-end gap-16 align-items-center">
              {/* <CustomFilter /> */}
              <CustomSearchBar
                value={keyword}
                setValue={setKeyword}
                onSearch={() => retrieveRedeemProductList()}
              />
              {/* add reawrd product button */}
              {!isRedemption && !isAddRedemePoint && (
                <CustomButton
                  icon={add}
                  text="Add Reward"
                  addIcon={true}
                  className="btnAdd justify-content-end"
                  onClick={(e) => clickAddRedeemPoint(e)}
                />
              )}
            </div>
          </div>

          {/* rewards table */}
          <div className="table_container product_table">
            <Table
              key={redeemProductList.total}
              ref={refProductTable}
              maxBodyHeight={redeemProductList.limit * 100}
              isLoading={redeemProductList.isLoading}
              grouping={redeemProductList.grouping}
              limit={redeemProductList.limit}
              page={redeemProductList.page}
              total={redeemProductList.total}
              data={redeemProductList.data}
              onPageChange={(page) => {
                setParamRedeemProduct({
                  ...paramRedeemProduct,
                  currentPage: page,
                });
                retrieveRedeemProductList(paramRedeemProduct);
              }}
              columns={[
                {
                  title: "No",
                  render: (row) => {
                    const startingIndex =
                      (redeemProductList.page - 1) * redeemProductList.limit +
                      1;
                    return startingIndex + row.tableData.index;
                  },
                  width: "80px",
                  align: "center",
                },
                {
                  title: "Image",
                  render: (row) => {
                    if (row.image == null || row.image == "") {
                      row.image = img_coming_soon;
                    }
                    return (
                      <img
                        src={row.image}
                        alt=""
                        className="d-block imgProduct"
                        onError={(e) => (e.target.src = img_coming_soon)}
                      />
                    );
                  },
                  width: "100px",
                },
                {
                  title: "Name",
                  render: (row) => {
                    if (row.name.length > 40) {
                      return String(row.name).substring(0, 39) + "...";
                    }
                    return row.name;
                  },
                  width: "100px",
                },
                {
                  title: "Point",
                  field: "pointRequired",
                  width: "50px",
                },
                {
                  title: "Quantity",
                  field: "quantity",
                  width: "50px",
                },
                {
                  title: "Start Date",
                  render: (row) => {
                    return apiUtil.getDateShortMonthFormat(row.startDate);
                  },
                  width: "110px",
                },
                {
                  title: "End Date",
                  render: (row) => {
                    return apiUtil.getDateShortMonthFormat(row.endDate);
                  },
                  width: "100px",
                },
                {
                  title: "Description",
                  render: (row) => {
                    if (row.description.length > 40) {
                      return String(row.description).substring(0, 39) + "...";
                    }
                    return row.description;
                  },
                  width: "80px",
                },
                {
                  title: "Edit",
                  render: (row) => {
                    return (
                      <Box
                        className=" cursor-pointer"
                        onClick={(e) => clickBtnEditRedeemProduct(e, row.id)}
                      >
                        <img src={edit} alt="" className="imgIcon" />
                      </Box>
                    );
                  },
                  width: "80px",
                  sorting: false,
                  align: "center",
                },
                {
                  title: "Delete",
                  render: (row) => {
                    return (
                      <Box
                        className=" cursor-pointer"
                        onClick={(e) => clickBtnDeleteRedeemProduct(e, row.id)}
                      >
                        <img src={delete_icon} alt="" className="imgIcon" />
                      </Box>
                    );
                  },
                  width: "80px",
                  sorting: false,
                  align: "center",
                },
              ]}
            />
          </div>
        </>
      )}

      {showView && (
        <>
          <div className="Actions space_between">
            <h6 className="title_text mt-2">Customer's Reward Detail</h6>
            <button className="btn btnClose" onClick={clickBtnClose}>
              <img src={close} className="imgClose" alt="imgClose" />
            </button>
          </div>

          <Formik
            initialValues={{
              itemName: getValueOrDefault(
                customerRewardProductDetail.itemName,
                ""
              ),
              memberType: getValueOrDefault(
                customerRewardProductDetail.memberType,
                ""
              ),
              point: getValueOrDefault(customerRewardProductDetail.point, ""),
              customerName: getValueOrDefault(
                customerRewardProductDetail.customerName,
                ""
              ),
              email: getValueOrDefault(customerRewardProductDetail.email, ""),
              phone: getValueOrDefault(customerRewardProductDetail.phone, ""),
              brancheName: getValueOrDefault(
                customerRewardProductDetail.branchName,
                ""
              ),
              redeemDate: getRewardDate(),
              status: getValueOrDefault(customerRewardProductDetail.status, ""),
              files: getRewardFiles(),
            }}
            enableReinitialize={true}
            validationSchema={AddRedeemProductFormValidation}
            validateOnBlur={false}
          >
            {({ values, errors, touched, setFieldValue }) => (
              <Form className="row form-container redeem_form">
                {values.itemName && (
                  <div className="col-12">
                    <CustomInput
                      name="itemName"
                      type="text"
                      label="Name"
                      customclass="input_wrapper"
                      hideicon="true"
                      readOnly
                    />
                  </div>
                )}
                {values.memberType && (
                  <div className="col-12 mt-2">
                    <CustomInput
                      name="memberType"
                      type="text"
                      label="Level"
                      customclass="input_wrapper"
                      hideicon="true"
                      readOnly
                    />
                  </div>
                )}
                {values.point && (
                  <div className="col-12 mt-2">
                    <CustomInput
                      name="point"
                      type="text"
                      label="Point"
                      customclass="input_wrapper"
                      hideicon="true"
                      readOnly
                    />
                  </div>
                )}
                {values.customerName && (
                  <div className="col-12 mt-2">
                    <CustomInput
                      name="customerName"
                      type="text"
                      label="Customer"
                      customclass="input_wrapper"
                      hideicon="true"
                      readOnly
                    />
                  </div>
                )}
                {values.email && (
                  <div className="col-12 mt-2">
                    <CustomInput
                      name="email"
                      type="text"
                      label="Email"
                      customclass="input_wrapper"
                      hideicon="true"
                      readOnly
                    />
                  </div>
                )}
                {values.phone && (
                  <div className="col-12 mt-2">
                    <CustomInput
                      name="phone"
                      type="text"
                      label="Phone"
                      customclass="input_wrapper"
                      hideicon="true"
                      readOnly
                    />
                  </div>
                )}
                {values.branchName && (
                  <div className="col-12 mt-2">
                    <CustomInput
                      name="branchName"
                      type="text"
                      label="Branch"
                      customclass="input_wrapper"
                      hideicon="true"
                      readOnly
                    />
                  </div>
                )}
                {values.redeemDate && (
                  <div className="col-12 mt-2">
                    <CustomInput
                      name="redeemDate"
                      type="text"
                      label="Redeem Date"
                      customclass="input_wrapper"
                      hideicon="true"
                      readOnly
                    />
                  </div>
                )}
                {values.status && (
                  <div className="col-12 mt-2">
                    <CustomSelect
                      options={status_list}
                      name="status"
                      label="Status"
                      isClearable={false}
                      placeholder="Select status"
                      value={status_list.find(
                        (option) => option.value === values.status
                      )}
                      onChange={(selectedOption) =>
                        setFieldValue("status", selectedOption.value)
                      }
                      disabled
                    />
                  </div>
                )}

                <div className="col-12 ">
                  <AntFileUpload name="files" label="Image" disabled />
                </div>
              </Form>
            )}
          </Formik>
        </>
      )}
      {/* customer reward tab */}

      {isRedemption && (
        <>
          {isEditCustomerRewardProduct ? (
            <>
              <div className="Actions space_between">
                <h6 className="title_text mt-2">Customer's Reward Detail</h6>
                <button className="btn btnClose" onClick={clickBtnClose}>
                  <img src={close} className="imgClose" alt="imgClose" />
                </button>
              </div>

              <Formik
                initialValues={{
                  itemName: getValueOrDefault(
                    customerRewardProductDetail.itemName,
                    ""
                  ),
                  memberType: getValueOrDefault(
                    customerRewardProductDetail.memberType,
                    ""
                  ),
                  point: getValueOrDefault(
                    customerRewardProductDetail.point,
                    ""
                  ),
                  customerName: getValueOrDefault(
                    customerRewardProductDetail.customerName,
                    ""
                  ),
                  email: getValueOrDefault(
                    customerRewardProductDetail.email,
                    ""
                  ),
                  phone: getValueOrDefault(
                    customerRewardProductDetail.phone,
                    ""
                  ),
                  brancheName: getValueOrDefault(
                    customerRewardProductDetail.branchName,
                    ""
                  ),
                  redeemDate: getRewardDate(),
                  status: getValueOrDefault(
                    customerRewardProductDetail.status,
                    ""
                  ),
                  files: getRewardFiles(),
                }}
                enableReinitialize={true}
                validateOnBlur={false}
                onSubmit={(values, actions) => {
                  onSubmitCustomerRewardProductHandler(values, actions);
                }}
              >
                {({ values, errors, touched, setFieldValue }) => (
                  <Form className="row form-container redeem_form">
                    {values.itemName && (
                      <div className="col-12">
                        <CustomInput
                          name="itemName"
                          type="text"
                          label="Name"
                          customclass="input_wrapper"
                          hideicon="true"
                          readOnly
                        />
                      </div>
                    )}
                    {values.memberType && (
                      <div className="col-12 mt-2">
                        <CustomInput
                          name="memberType"
                          type="text"
                          label="Level"
                          customclass="input_wrapper"
                          hideicon="true"
                          readOnly
                        />
                      </div>
                    )}
                    {values.point && (
                      <div className="col-12 mt-2">
                        <CustomInput
                          name="point"
                          type="text"
                          label="Point"
                          customclass="input_wrapper"
                          hideicon="true"
                          readOnly
                        />
                      </div>
                    )}
                    {values.customerName && (
                      <div className="col-12 mt-2">
                        <CustomInput
                          name="customerName"
                          type="text"
                          label="Customer"
                          customclass="input_wrapper"
                          hideicon="true"
                          readOnly
                        />
                      </div>
                    )}
                    {values.email && (
                      <div className="col-12 mt-2">
                        <CustomInput
                          name="email"
                          type="text"
                          label="Email"
                          customclass="input_wrapper"
                          hideicon="true"
                          readOnly
                        />
                      </div>
                    )}
                    {values.phone && (
                      <div className="col-12 mt-2">
                        <CustomInput
                          name="phone"
                          type="text"
                          label="Phone"
                          customclass="input_wrapper"
                          hideicon="true"
                          readOnly
                        />
                      </div>
                    )}
                    {values.branchName && (
                      <div className="col-12 mt-2">
                        <CustomInput
                          name="branchName"
                          type="text"
                          label="Branch"
                          customclass="input_wrapper"
                          hideicon="true"
                          readOnly
                        />
                      </div>
                    )}
                    {values.redeemDate && (
                      <div className="col-12 mt-2">
                        <CustomInput
                          name="redeemDate"
                          type="text"
                          label="Redeem Date"
                          customclass="input_wrapper"
                          hideicon="true"
                          readOnly
                        />
                      </div>
                    )}
                    {values.status && (
                      <div className="col-12 mt-2">
                        <CustomSelect
                          options={status_list}
                          name="status"
                          label="Status"
                          isClearable={false}
                          placeholder="Select status"
                          value={status_list.find(
                            (option) => option.value === values.status
                          )}
                          onChange={(selectedOption) =>
                            setFieldValue("status", selectedOption.value)
                          }
                          disabled={values.status === 2 || values.status === 3}
                        />
                      </div>
                    )}

                    <div className="col-12 mt-2">
                      <AntFileUpload name="files" label="Image" disabled />
                    </div>

                    <div className="form-group mt-4">
                      <div className="Actions justify-content-end">
                        <button
                          type="button"
                          className="button btnCancel"
                          onClick={clickBtnClose}
                        >
                          Cancel
                        </button>
                        <button type="submit" className="button btnSave">
                          Update
                        </button>
                      </div>
                    </div>
                  </Form>
                )}
              </Formik>
            </>
          ) : null}

          {/* banner & actions */}
          <div className="Actions space_between">
            {/* banner */}
            <h6 className="title_text mt-2">Customer's Rewards</h6>

            {/* actions */}
            <div className="d-flex justify-content-end gap-16 align-items-center">
              <CustomSearchBar
                value={keyword}
                setValue={setKeyword}
                onSearch={() => retrieveRedemptionList()}
              />
              <CustomButton
                text="Gift"
                addIcon={false}
                className={`btnAdd justify-content-end ${
                  activeGiftPoint === 1 ? "buttonActive" : ""
                }`}
                onClick={() => clickActiveGiftPoint(1)}
              />
              <CustomButton
                text="Coupon"
                addIcon={false}
                className={`btnAdd justify-content-end ${
                  activeGiftPoint === 2 ? "buttonActive" : ""
                }`}
                onClick={() => clickActiveGiftPoint(2)}
              />
            </div>
          </div>

          {/* rewards table */}
          <div className="table_container redemption_table">
            <Table
              ref={refRedemptionTable}
              maxBodyHeight={redemptionList.limit * 100}
              isLoading={redemptionList.isLoading}
              grouping={redemptionList.grouping}
              limit={redemptionList.limit}
              page={redemptionList.page}
              total={redemptionList.total}
              data={redemptionList.data}
              onPageChange={(page) => {
                setParamRedemption({
                  ...paramRedemption,
                  currentPage: page,
                });
                retrieveRedemptionList();
              }}
              columns={[
                {
                  title: "No",
                  render: (row) => {
                    const startingIndex =
                      (redemptionList.page - 1) * redemptionList.limit + 1;
                    return startingIndex + row.tableData.index;
                  },
                  width: "80px",
                  align: "center",
                },
                {
                  title: "Image",
                  render: (row) => {
                    return (
                      <>
                        {row.image == null || row.image == "" ? (
                          "-"
                        ) : (
                          <img
                            src={row.image}
                            alt=""
                            className="d-block imgProduct"
                            onError={(e) => (e.target.src = img_coming_soon)}
                          />
                        )}
                      </>
                    );
                  },
                  width: "5px",
                },

                {
                  title: "Name",
                  render: (row) => {
                    if (row.itemName == "") {
                      return "-";
                    }
                    if (row.itemName.length > 40) {
                      return String(row.name).substring(0, 39) + "...";
                    }
                    return row.itemName;
                  },
                  width: "100px",
                },
                {
                  title: "Level",
                  field: "memberType",
                  width: "80px",
                },
                {
                  title: "Point",
                  render: (row) => {
                    return (
                      <>
                        {row.point ? (
                          <div className="point">{row.point} Points</div>
                        ) : (
                          "-"
                        )}
                      </>
                    );
                  },
                  width: "100px",
                },
                {
                  title: "Customer",
                  field: "customerName",
                  width: "100px",
                },
                {
                  title: "Branches",
                  render: (row) => {
                    if (row.branchName === "" || row.branchName === null) {
                      return "-";
                    }
                    return row.branchName;
                  },
                  width: "100px",
                },
                {
                  title: "Redeem Date",
                  render: (row) => {
                    return apiUtil.getDateShortMonthFormat(row.redeemDate);
                  },
                  width: "150px",
                },
                {
                  title: "Status",
                  render: (row) => {
                    const getStatus = () => {
                      switch (row.status) {
                        case 0:
                          return {
                            statusName: "Cancelled",
                            statusClassName: "status-rejected",
                          };
                        case 1:
                          return {
                            statusName: "Pending",
                            statusClassName: "status-pending",
                          };
                        case 2:
                          return {
                            statusName: "Approved",
                            statusClassName: "status-approved",
                          };
                        case 3:
                          return {
                            statusName: "Rejected",
                            statusClassName: "status-rejected",
                          };
                        default:
                          return {};
                      }
                    };
                    return (
                      <div
                        className={` status-container ${
                          getStatus().statusClassName
                        } `}
                      >
                        <div className="status-dot"></div>
                        {getStatus().statusName}
                      </div>
                    );
                  },
                  width: "100px",
                },
                {
                  title: "Edit",
                  render: (row) => {
                    return (
                      <Box
                        className=" cursor-pointer"
                        onClick={(e) => clickBtnEditCustomerReward(e, row.id)}
                      >
                        <img src={edit} alt="" className="imgIcon" />
                      </Box>
                    );
                  },
                  width: "80px",
                  sorting: false,
                  align: "center",
                },
                {
                  title: "View",
                  sorting: false,
                  render: (row) => {
                    return (
                      <Box
                        className="cursor-pointer"
                        onClick={(e) =>
                          clickBtnEditCustomerReward(e, row.id, "view")
                        }
                      >
                        <img src={view} alt="" className="imgIcon" />
                      </Box>
                    );
                  },
                  width: "80px",
                  align: "center",
                },
              ]}
            />
          </div>
        </>
      )}
    </>
  );
};

export default Redeem;
